<template>
	<div class="el-col-sm-24" style="margin: 5px;">
		<el-tooltip v-if="rate"
					placement="bottom" :open-delay="500"
					:content="$t('investor.exchange.table.retentionSwitch.disabled.mandatory.tooltip', { currency: currency })"
					:disabled="!isRetentionMandatory"
		>
			<md-switch v-model="params.data[params.useRetentionField]" :disabled="isRetentionMandatory">
				<span :class="{'accent_color': useRetention}">
					{{ value }}
				</span>
			</md-switch>
		</el-tooltip>
		<span v-else>{{ value }}</span>
	</div>
</template>
<script>

import {formatAsPercentage} from "@/common/format";

export default {
	computed: {
		currency() {
			return this.params.data[this.params.currencyField];
		},
		isRetentionMandatory() {
			return this.params.data[this.params.retentionMandatoryField];
		},
		useRetention() {
			return this.params.data[this.params.useRetentionField];
		},
		rate() {
			return this.params.data[this.params.retentionRateField];
		},
		value() {
			return formatAsPercentage(this.rate, { showEmptyAsNotAvailable: true, decimals: 0 });
		},
	}
};
</script>